import { render, staticRenderFns } from "./LockScreen.vue?vue&type=template&id=6087a954&"
import script from "./LockScreen.vue?vue&type=script&lang=js&"
export * from "./LockScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports